export default {
  title: 'Ricevuta stampata',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Nascondi commissione di servizio sulla ricevuta',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Nascondi sezione prezzi sulla ricevuta',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Nascondi nomi gruppi modificatori sulla ricevuta',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
